// based on rc-upload 2.4.4
// export this package's api
import Upload from './Upload'

export default Upload



// WEBPACK FOOTER //
// ./components/vc-upload/src/index.js